import React from 'react';
import MyProFileView from '../../Views/AfterAuth/MyProfileView/MyProFileView';

const Profile = () => {
    return <MyProFileView />;
};

export default Profile;
